export const extractedFilesToolbarButtonStyles = {
  button: {
    width: "150px",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
};

export const extractedFilesToolbarFilterItemStyles = {
  minWidth: "120px",
  overflow: "auto",
  width: "100%"
};
